<template>
  <div :key="refreshKey">

    <template v-if="clickableLineItems">
      <v-list-item @click.stop="clickLineItem">
        <v-list-item-content>
          <p v-if="isDone === true" class="text-subtitle-2">
            <del>{{ lineItem.quantity }} x {{ lineItem.label }}</del>
          </p>
          <p v-else class="text-subtitle-2">
            {{ lineItem.quantity }} x {{ lineItem.label }}
          </p>
          <v-list-item-subtitle>
            {{ lineItem.comment }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="dynamic-description" v-if="dynamicDescription !== ''" v-html="dynamicDescription"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- Unclickable line items-->
    <template v-else>

      <v-list-item>
         <!-- Strike Through line-items when they've been printed before. -->
        <v-list-item-content v-if="lineItem.printed && lineItemMetaData">
          <p class="text-subtitle-1 font-weight-bold text-decoration-line-through">
            {{ lineItem.quantity }} x {{ lineItem.label }}
          </p>
          <v-list-item-subtitle>
            {{ lineItem.comment }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="dynamic-description" v-if="dynamicDescription !== ''" v-html="dynamicDescription"></v-list-item-subtitle>

        </v-list-item-content>
        
        <!-- Normal when line-items have not been printed b4. -->
        <v-list-item-content v-else>
          <p class="text-subtitle-1 font-weight-bold">
            {{ lineItem.quantity }} x {{ lineItem.label }}
          </p>
          <v-list-item-subtitle>
            {{ lineItem.comment }}
          </v-list-item-subtitle>
          <v-list-item-subtitle class="dynamic-description" v-if="dynamicDescription !== ''" v-html="dynamicDescription"></v-list-item-subtitle>

        </v-list-item-content>

      </v-list-item>
    </template>

  </div>
</template>

<script>
export default {
  name: 'LineItemListItem',
  props: {
    lineItem: {
      type: Object,
      required: true
    },
    orderState: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      refreshKey: 0
    }
  },
  methods: {
    clickLineItem() {

      const currentStatus = this.orderStates.find(state => {
        return state.key === this.lineItem.status
      })

      const newStatus = currentStatus.nextStep //eslint-disable-line

      if(currentStatus.key !== 'delivered') {
        this.lineItem.status = 'delivered' //newStatus
        this.$store.dispatch('updateLineItemStatus', {uuid: this.lineItem.uuid, newStatus: 'delivered'})
      } 
      
      else {
        this.lineItem.status = 'completed' //newStatus
        this.$store.dispatch('updateLineItemStatus', {uuid: this.lineItem.uuid, newStatus: 'completed'})
      }
    }
  },
  computed: {
    isDone() {
      if(this.lineItem === null || this.lineItem.status === null || typeof this.lineItem.status === 'undefined' || this.orderState === null) {
        return false
      }
      return this.lineItem.status === 'delivered'
    },
    clickableLineItems() {
      return this.$store.state.processDisplaySystem !== null && typeof this.$store.state.processDisplaySystem !== 'undefined' && this.$store.state.processDisplaySystem.clickableLineItems === true
    },
    dynamicDescription() {
      if(
        this.lineItem.dynamicDescription !== null &&
        this.lineItem.dynamicDescription !== undefined &&
        this.lineItem.dynamicDescription !== '') {
        return this.lineItem.dynamicDescription
      }
      return ''
    },
    orderStates() {
      return this.$store.state.orderStates
    },
    lineItemMetaData() {
      let lineItemData = null
      if (this.lineItem?.data) {
        try {
          lineItemData = JSON.parse(this.lineItem.data)
        } catch(e) {
          return lineItemData
        }

        if (!lineItemData?.metadata) {
          return lineItemData
        }

        return lineItemData.metadata
      }
      return lineItemData
    }
  }
}
</script>